import {
  FINANCIAL_RESULTS_REPORT,
  REVENUE_STATEMENT,
  ACTUAL_IMPLEMENTATION,
  DETAILS_OF_EXPENSES,
  EXPENSE_BY_ARTICLES_REPORT,
  SALARY_REPORT,
} from '@app/constants';

export const TABS_WITH_EXCEL_EXPORT = [
  FINANCIAL_RESULTS_REPORT,
  REVENUE_STATEMENT,
  ACTUAL_IMPLEMENTATION,
  DETAILS_OF_EXPENSES,
  EXPENSE_BY_ARTICLES_REPORT,
  SALARY_REPORT,
];
